import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';
import buildNestedy from '@/modules/nestedy';
import ModuleLoader from '@/modules/module_loader';
import Tag from '@/modules/tag';
import Zipcoder from '@/modules/zipcoder';

export default class extends Controller {
  static targets = ['absorbTax'];

  connect() {
    this.options = ModuleLoader.getOptions();
    this.tickets = document.querySelector('[data-tickets]');
    this.trails = document.querySelector('[data-trails]');
    this.year = new Date().getFullYear();
    this.yearRange = [this.year - 1, this.year + 1];

    this.nestedy();
    this.tags();
    this.bindTrailType(document);

    for (const item of this.tickets.querySelectorAll('.nestedy-item')) {
      this.bindTicketCalculation(item);
    }

    new Zipcoder({ scope: 'personal' }).create();
  }

  bindTicketCalculation(item) {
    const amount = item.querySelector('[data-ticket-amount]');

    if (amount) amount.addEventListener('blur', () => this.calculateTicket(item));
  }

  bindTrailType(context) {
    context.querySelectorAll('[data-trail-type]').forEach((item) => {
      item.addEventListener('change', (evt) => {
        const selected = evt.currentTarget;

        selected
          .closest('[data-trail-type-wrapper]')
          .querySelectorAll('[data-trail-type]')
          .forEach((select) => {
            if (selected.value !== '' && selected !== select) {
              select.value = '';
            }
          });
      });
    });
  }

  calculateTicket(item) {
    if (item.style.display === 'none') return;

    const amountCents = item.querySelector('[data-ticket-amount]').value.replace(/[^\d]/g, '');

    ajax({
      body: {
        absorb_tax: this.absorbTaxTarget.checked,
        amount_cents: amountCents,
        event_id: this.options.event_id,
        promoter_id: this.options.promoter_id,
      },
      done: (json) => this.updateTicketPrice(json, item),
      method: 'POST',
      url: this.options.calculate_ticket_uri,
    });
  }

  calculateTickets() {
    for (const item of this.tickets.querySelectorAll('.nestedy-item')) {
      this.calculateTicket(item);
    }
  }

  nestedy() {
    buildNestedy(this.tickets, {
      add: (item) => {
        this.bindTicketCalculation(item);
      },
      change: (count) => document.querySelector('[data-tickets-none]').classList.toggle('hidden', count > 0),
      template: '#event-ticket-template',
    }).init();

    buildNestedy(this.trails, {
      add: (item) => this.bindTrailType(item),
      change: (count) => document.querySelector('[data-trails-none]').classList.toggle('hidden', count > 0),
      template: '#event-trail-template',
    }).init();
  }

  tags() {
    new Tag({
      field: $('#complety__rhythm'),
      keys: ['name'],
      name: 'event[tags][]',
      removeImage: this.options.tag.removeImage,
      template: 'rhythms',
      textAttribute: 'name',
      valueAttribute: 'slug',
      wrapper: $('.tags'),
    }).create();
  }

  updateTicketPrice(json, item) {
    item.querySelector('[data-ticket-tax]').value = json.tax;
    item.querySelector('[data-ticket-profit]').value = json.profit;
    item.querySelector('[data-ticket-total]').value = json.total;
  }
}
